import noop from "utilities/src/react/noop";
export const useOnMobileAppState = noop;
